import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { Configuration } from '../configuration/configurations';
import { AlertService} from '../_services';

@Injectable()
export class AuthGuard implements CanActivate {
    private themeWrapper = document.querySelector('body');
    constructor(private router: Router,
        private _configuration: Configuration, private route: ActivatedRoute,private alertService: AlertService
    ) { }

    canActivate(rout: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // if (rout.queryParams['authdata']) {
        //     let testdata = atob(rout.queryParams['authdata']);
        //     console.log("testdata", testdata);
        //     let response = JSON.parse(testdata);
        //     console.log("jsondata", response);
        //     localStorage.removeItem("PrimaryColor")
        //     this.themeWrapper.style.removeProperty('--colorPrimary');
        //     localStorage.removeItem("SecondaryColor")
        //     this.themeWrapper.style.removeProperty('--colorSecondary');
        //     localStorage.removeItem("clientLogo");
        //     localStorage.setItem('currentUser', JSON.stringify(response));

        //     let access_token = response['access_token'];
        //     let token_type = response['token_type'];
        //     let expires_in = response['expires_in'];
        //     let role = response['roleName'];
        //     let user = response['User'];
        //     let username = response['UserName'];
        //     let displayname = response['DisplayName'];
        //     let clientcode = response['ClientCode'];
        //     let ClientName = response["ClientName"];
        //     let rate = response['Rate'];
        //     let Extensions = response["Extensions"];
        //     let ServerId = response["ServerID"];
        //     let clientlogo = response["Logo"];
        //     let clientPrimaryColor = response["PrimaryColor"];
        //     let clientSecondaryColor = response["SecondaryColor"];
        //     let dnsName = response["DnsName"];
        //     console.log("Client Primary Color", clientPrimaryColor)
        //     console.log("Client Secondary Color", clientSecondaryColor)
        //     localStorage.setItem("Authorization", JSON.stringify(token_type + ' ' + access_token));
        //     localStorage.setItem("role", role);
        //     localStorage.setItem("user", user);
        //     localStorage.setItem("userName", username);
        //     localStorage.setItem("displayName", displayname);
        //     localStorage.setItem("clientcode", clientcode);
        //     localStorage.setItem("rate", rate);
        //     localStorage.setItem("Extensions", Extensions);
        //     localStorage.setItem("ClientName", ClientName);
        //     localStorage.setItem("ServerId", ServerId)
        //     if (clientPrimaryColor) {
        //         localStorage.setItem("PrimaryColor", clientPrimaryColor)
        //         this.themeWrapper.style.setProperty('--colorPrimary', clientPrimaryColor);
        //     }
        //     if (clientSecondaryColor) {
        //         localStorage.setItem("SecondaryColor", clientSecondaryColor)
        //         this.themeWrapper.style.setProperty('--colorSecondary', clientSecondaryColor);
        //     }
        //     if (clientlogo) {
        //         localStorage.setItem("clientLogo", clientlogo);
        //     }

        //     localStorage.setItem("clientPrimaryColor", clientPrimaryColor);
        //     localStorage.setItem("clientSecondaryColor", clientSecondaryColor);
        //     if (dnsName != "") {
        //         localStorage.setItem("isfromDns", "true");
        //         localStorage.setItem("DnsName", dnsName);
        //         let urlwithdns = this._configuration.baseUrlToken;
        //         urlwithdns = urlwithdns.replace("www", dnsName);
        //         localStorage.setItem("ReselerUrl", urlwithdns);
        //     }
        //     //     this._router.navigateByUrl('/sidebar', { skipLocationChange: true }).then(() =>
        //     //     this._router.navigate(['/dashboard'])
        //     // );
        // }

        if (localStorage.getItem('currentUser')) {
            debugger;
            // logged in so return true
            if ((rout.routeConfig.path == "addtasktime" || rout.routeConfig.path == "allocatehistory") && localStorage.getItem('TaskEnabled') == 'N') {
                //window.location.href = this._configuration.baseUrlToken + "/unauthenticationuser";
                this.router.navigate(['/unauthenticationuser']);
            }

            return true;
        }



        //this.router.navigate(['/app/login']);
        //        window.location.href = this._configurations.baseUrlToken + "/login";
        window.location.href = this._configuration.baseUrlToken + "/login";

        return false;
    }
}